import UserPermissions from './user-permissions/UserPermissions';
import ComponentHelper from '../../supers/ComponentHelper';
import UserActivity from './user-activity/UserActivity';
import UserInfo from './user-info/UserInfo';
import React from 'react';
import './user-profile.css';

class UserProfile extends ComponentHelper {
	render() {
		return (
			<div className="user-profile animated fadeIn">
				<h1>Your profile</h1>
				<div className="hbox">
					<div className="grow-1 left-col">
						<UserInfo />
						<UserPermissions />
					</div>
					<div className="grow-1 right-col">
						<UserActivity />
					</div>
				</div>
			</div>
		);
	}
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/user-profile/UserProfile.js